import React, { useEffect }  from 'react';
import { Button, makeStyles, colors } from '@material-ui/core';
import {  ModalFormulario,ModalGeneral,Tabla } from 'components';
import { AddBox, Delete, Publish } from '@material-ui/icons';
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const useStyles = makeStyles((theme) => ({

  add: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    color: "white",
    backgroundColor: theme.palette.add.main,
    "&:hover": {
      backgroundColor: theme.palette.add.dark,
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    height: "50%",
  },
  btnAceptar: {
    color: colors.green[500],
    "&:hover": {
      color: theme.palette.success.dark,
      },
  },
  btnBorrar: {
    color: colors.red[500],
    "&:hover": {
      color: theme.palette.warning.light,
      },
  },
}));

const getErrorMessage=(data)=>{
  let palor={};
  Object.keys(data).forEach(k=>palor={...palor,[k]:data[k].message})
  return  palor;
}
const CuerpoCatalogo = (props) => {
  const {keyTabla,servicios,columns,data,id,modal,setModal,mAdvertencia,setMAdvertencia,form,handleSubmit, catalogo,permisos}=props;
  const classes = useStyles();
  const classesTablero = useStylesTablero();
  
  const cerrarModal=()=>setModal({open:false});
  const cerrarAdvertencia=()=>setMAdvertencia({open:false});
  
  const clickNuevo = () => setModal({open:true});
  const clickEditar=(item)=>setModal({open:true,item:item,id:item[id]});

  const clickBaja=(estatus)=>(seleccionados)=>()=>setMAdvertencia({
    open:true,
    // mensaje:seleccionados.length+' Elementos seleccionados serán dados de '+(estatus?'alta':'baja')+', ¿Está segúro de continuar?',
    mensaje:(seleccionados.length > 1 ? seleccionados.length+' Elementos seleccionados serán dados de '+(estatus == 9?'alta':'baja')+', ¿Está seguro de continuar?' : seleccionados.length+' Elemento seleccionado será dado de '+(estatus==9?'alta':'baja')+', ¿Está seguro de continuar?'),
    aceptar:()=>servicios.baja({estatus:estatus,ids:seleccionados.map(i=>i[id])}),
  });
  const abrirAdvertencia=(aceptar)=>data=>setMAdvertencia({
    open:true,
    mensaje:'Asegúrese de que todos los datos son correctos antes de continuar con esta acción',
    aceptar:()=>aceptar(data), 
  });
  // si existe permisos verifica si tiene permiso para ejecutar la accion caso contrario siempre tiene permisos
  const acciones=[
    {label:"AGREGAR NUEVO", icon:<AddBox/>,click:(data)=>clickNuevo,disabled:permisos&&!permisos["crear"], color: classes.add},
    {label:"DESACTIVAR",icon:<Delete/>,click:clickBaja(10),dataSelected:true, color: classes.btnBorrar},
    {label:"ACTIVAR",icon:<Publish/>,click:clickBaja(9),dataSelected:true, color: classes.btnAceptar}
  ]
  const accionesFila=[
    {label:'EDITAR',onClick:clickEditar,enabled:permisos&&permisos["editar"]},
  ];
  
  // console.log('estamos en grupo');
  // console.log(permisos);
  return (
    <React.Fragment>
      <Tabla 
        keyTabla={keyTabla}
        rows={data} 
        columns={columns} 
        accionesTabla={acciones} 
        accionesFila={accionesFila} 
        isSeleccionable={true}
        columnKey={id} 
      />
      <ModalFormulario
        open={modal.open}
        titulo={(modal.item?'ACTUALIZAR ' + catalogo + ' # ':'AGREGAR ')+" "+(modal.id ? modal.id : catalogo.toUpperCase())}
        aceptar={handleSubmit(abrirAdvertencia(
          modal.item?(data)=>servicios.update({...data,id:modal.id}):servicios.insert)
        )}
        OnCancelar={cerrarModal}
      >
        {form}
      </ModalFormulario>
      <ModalGeneral
        open={mAdvertencia.open}
        titulo="Advertencia"
        ContenidoMensaje={mAdvertencia.mensaje}
        acciones={<React.Fragment>
          <Button onClick={cerrarAdvertencia} className={classesTablero.btnEliminar}>Cancelar</Button>
          <Button color="primary" onClick={mAdvertencia.aceptar} className={classesTablero.btnAceptar}>ACEPTAR</Button>
        </React.Fragment>}
      />
    </React.Fragment>
  );
};

export default CuerpoCatalogo;